// src/services/devRenderService.js

import axios from "axios";

const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://localhost:7231";

export async function renderDevPreview(payload) {
    const response = await axios.post(
        `${API_BASE_URL}/api/dev-render/preview`,
        payload
    );

    return response.data;
}